import { useParams } from "react-router-dom";
import { getDocument } from "../api/content";
import { useAsync } from "../hooks/useAsync";
import { Loading, ErrorState } from "../components/Spinner";
import { DocumentView } from "../components/document/DocumentView";

/**
 * Canonical detail page for any searchable item, addressed by its content id
 * (e.g. /documents/PHOTO-7, /documents/ARTICLE-3). Renders the item and its
 * comment thread. Journal entries also have the friendlier /blog/:slug URL,
 * which renders the very same view.
 */
export function DocumentPage() {
  const { contentId = "" } = useParams();
  const { data: doc, loading, error } = useAsync(
    () => getDocument(contentId),
    [contentId],
  );

  if (loading) {
    return (
      <div className="page">
        <div className="container">
          <Loading label="Retrieving item…" />
        </div>
      </div>
    );
  }

  if (error || !doc) {
    return (
      <div className="page">
        <div className="container">
          <ErrorState label={error ?? "That item could not be found."} />
        </div>
      </div>
    );
  }

  return <DocumentView doc={doc} />;
}
